// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    versionText: {
      textAlign: 'right',
      marginLeft: 13,
      fontWeight: 'bold',
      color: '#fff',

      '&:hover': {
        cursor: 'pointer',
      },
    },
  }),
);

export default useStyles;
